// Abgelaufene Sitzung verständlich melden (Testplan M7).
//
// Die auth-bridge stellt ein Supabase-JWT mit fester Laufzeit aus (`expiresAt`), ein Refresh gibt es
// nicht (autoRefreshToken: false). Läuft es ab, antworten RPCs und Edge Functions mit 401, und die
// Oberfläche zeigte bisher nur „HTTP 401“. Ein Reload des iframes hilft nicht (er tauscht denselben
// abgelaufenen appToken erneut, siehe main.ts); erst ein neu geöffnetes Fenster holt einen frischen.

export const SESSION_EXPIRED_TEXT =
  'Sitzung abgelaufen. Bitte die Seite mit F5 neu laden, dann geht es weiter.';

/** Fehlertext für eine HTTP-Antwort ohne eigene Meldung: 401 heißt hier immer „Sitzung abgelaufen“. */
export function httpErrorText(status: number): string {
  return status === 401 ? SESSION_EXPIRED_TEXT : `HTTP ${status}`;
}

/** Millisekunden bis zum Ablauf; null bei unlesbarem Zeitpunkt. */
export function msUntilExpiry(expiresAt: string, now: number = Date.now()): number | null {
  const t = Date.parse(expiresAt);
  return Number.isNaN(t) ? null : t - now;
}

/** true, wenn die URL an unser Supabase-Projekt geht (REST, RPC, Edge Functions). */
export function isOwnApiUrl(url: string, supabaseUrl: string): boolean {
  const base = supabaseUrl.replace(/\/+$/, '');
  return url === base || url.startsWith(`${base}/`);
}

function requestUrl(input: RequestInfo | URL): string {
  if (typeof input === 'string') return input;
  if (input instanceof URL) return input.href;
  return input.url;
}

let bannerShown = false;

function showExpiredBanner(): void {
  if (bannerShown) return;
  bannerShown = true;
  const el = document.createElement('div');
  el.className = 'v-banner v-banner-error';
  el.setAttribute('role', 'alert');
  el.style.cssText = 'position:fixed;top:8px;left:8px;right:8px;z-index:10000;';
  el.innerHTML = `<span class="v-icon fa-regular fa-circle-exclamation"></span><span>${SESSION_EXPIRED_TEXT}</span>`;
  document.body.prepend(el);
}

/**
 * Meldet eine abgelaufene Sitzung mit einem festen Hinweis oben: zum Ablaufzeitpunkt und sobald unser
 * Backend mit 401 antwortet. Muss VOR createClient laufen, weil supabase-js `fetch` beim Erzeugen bindet.
 */
export function watchSessionExpiry(expiresAt: string, supabaseUrl: string): void {
  const ms = msUntilExpiry(expiresAt);
  // setTimeout verträgt höchstens rund 24,8 Tage; die Sitzung lebt deutlich kürzer.
  if (ms != null && ms < 2_147_000_000) setTimeout(showExpiredBanner, Math.max(0, ms));

  const original = window.fetch.bind(window);
  window.fetch = async (input: RequestInfo | URL, init?: RequestInit) => {
    const res = await original(input, init);
    if (res.status === 401 && isOwnApiUrl(requestUrl(input), supabaseUrl)) showExpiredBanner();
    return res;
  };
}
